import { render, staticRenderFns } from "./AddInvestmentModal.vue?vue&type=template&id=fdd66720&scoped=true"
import script from "./AddInvestmentModal.vue?vue&type=script&lang=js"
export * from "./AddInvestmentModal.vue?vue&type=script&lang=js"
import style0 from "./AddInvestmentModal.vue?vue&type=style&index=0&id=fdd66720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd66720",
  null
  
)

export default component.exports